import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../../API';
import { validateLoginForm, getInstantPhoneError } from '../../Utils/validateForm';
import { useAuth } from '../../Context/AuthContext';

export default function useLoginForm() {
  const [values, setValues] = useState({
    phone_number: '',
    password: ''
  });


  const [errors, setErrors] = useState({});
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({ ...prev, [name]: value }));
    // تحقق فوري من صحة رقم الهاتف
    if (name === 'phone_number') {
      const phoneError = getInstantPhoneError(value);
      if (phoneError) {
        setErrors((prev) => ({ ...prev, phone_number: phoneError }));
      } else {
        setErrors((prev) => {
          const { phone_number, ...rest } = prev;
          return rest;
        });
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setIsLoading(true);

    const validationErrors = validateLoginForm(values);
    if (Object.keys(validationErrors).length === 0) {
      try {
        const res = await loginUser({
          phone_number: values.phone_number,
          password: values.password
        });

        // تحقق من الدور
        const user = res.user || res.data?.user || res;

        if (!user || user.role !== 'super_admin') {
          setError("الدخول مسموح فقط للمشرف ");
          setIsLoading(false);
          return;
        }

        // تخزين البيانات في Context والكوكيز
        const loginData = {
          user: user,
          access: res.access || res.access_token || res.accessToken,
          refresh: res.refresh || res.refresh_token || res.refreshToken
        };

        login(loginData);
        setSuccess("تم تسجيل الدخول بنجاح!");
        setTimeout(() => navigate("/home"), 800);

      } catch (error) {
        let msg = "فشل تسجيل الدخول. تحقق من البيانات أو الشبكة.";

        if (error.response && error.response.data) {
          const { data } = error.response;
          if (typeof data === "string") {
            msg = data;
          } else if (typeof data === "object") {
            if (data.message) {
              msg = data.message;
            } else if (data.error) {
              msg = data.error;
            } else if (data.detail) {
              msg = data.detail;
            } else {
              msg = Object.values(data).flat().join("، ");
            }
          }
        } else if (error.message) {
          msg = error.message;
        }

        setError(msg);
      }
    } else {
      setErrors(validationErrors);
    }

    setIsLoading(false);
  };

  return {
    values,
    errors,
    error,
    isLoading,
    success,
    handleChange,
    handleSubmit
  };
} 
